module.exports = __webpack_public_path__ + "9f24a3db06c9401a61f41f6314d7cf9f.svg";